import classNames from "classnames";
import { User } from "firebase/auth";
import React, { useCallback, useState } from "react";
import FileImporter from "./FileImporter";
import "./ImportVCDataForm.scss";

interface ImportVCDataFormProps {
  fireUser: User;
}

const ImportVCDataForm: React.FC<ImportVCDataFormProps> = ({ fireUser }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const handleDragEnter = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const droppedFile = e.dataTransfer?.files?.[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
    return false;
  }, []);

  const handleDragOver = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleFileChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault();
      setIsDragging(false);

      const droppedFile = e.target.files?.[0];
      if (droppedFile) {
        setFile(droppedFile);
      }

      e.target.value = "";
      // Prevent the default behavior of the input element:
      return false;
    },
    [],
  );

  const handleClick = useCallback(() => {
    const input = document.getElementById("file-input");
    if (input) {
      input.click();
    }
  }, []);

  const dropzoneClassName = classNames("dropzone-container", {
    "is-dragging": isDragging,
  });

  return (
    <div className="import-vc-data-form">
      <div className="form-header">Import Data</div>
      <div
        className={dropzoneClassName}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleClick}
        draggable={false}
      >
        {isDragging ? (
          <div className="dropzone-text">Drop the file here</div>
        ) : (
          <div className="dropzone-text">
            Drag and drop a CSV file here or click to upload and import VC data.
          </div>
        )}
        <input
          id="file-input"
          type="file"
          accept=".csv"
          onChange={handleFileChange}
          className="d-none"
        />
      </div>
      <FileImporter file={file} fireUser={fireUser} />
    </div>
  );
};

export default ImportVCDataForm;
